import React from "react";

// A camera-aperture + eye motif for mEYEtasks.
// Spins subtly. Fuchsia + cyan dual accent.
export const ApertureEye = ({ size = 28, spin = true, className = "" }) => {
    const cx = 50,
        cy = 50,
        r = 34;
    const blades = 6;
    const paths = [];
    for (let i = 0; i < blades; i++) {
        const a1 = (i / blades) * Math.PI * 2;
        const a2 = ((i + 1) / blades) * Math.PI * 2;
        const x1 = cx + r * Math.cos(a1);
        const y1 = cy + r * Math.sin(a1);
        const x2 = cx + r * Math.cos(a2);
        const y2 = cy + r * Math.sin(a2);
        const midX = cx + r * 0.35 * Math.cos((a1 + a2) / 2);
        const midY = cy + r * 0.35 * Math.sin((a1 + a2) / 2);
        paths.push(`M ${x1} ${y1} Q ${midX} ${midY} ${x2} ${y2}`);
    }

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            className={className}
            aria-label="mEYEtasks aperture eye"
            data-testid="aperture-eye-logo"
        >
            <defs>
                <radialGradient id="pupilGrad" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.95" />
                    <stop offset="60%" stopColor="#d946ef" stopOpacity="0.7" />
                    <stop offset="100%" stopColor="#050505" stopOpacity="1" />
                </radialGradient>
                <linearGradient id="bladeGrad" x1="0" x2="1" y1="0" y2="1">
                    <stop offset="0%" stopColor="#22d3ee" />
                    <stop offset="100%" stopColor="#d946ef" />
                </linearGradient>
            </defs>
            <g className={spin ? "aperture-spin" : ""} style={{ transformOrigin: "50% 50%" }}>
                <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke="#27272a" strokeWidth="1" />
                {paths.map((d, i) => (
                    <path
                        key={i}
                        d={d}
                        fill="none"
                        stroke="url(#bladeGrad)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        opacity={0.85 - i * 0.05}
                    />
                ))}
                <circle cx={cx} cy={cy} r={r} fill="none" stroke="#22d3ee" strokeWidth="1" opacity="0.35" />
            </g>
            {/* pupil (does not spin) */}
            <circle cx={cx} cy={cy} r={r * 0.42} fill="url(#pupilGrad)" />
            <circle cx={cx - 3} cy={cy - 4} r={2.4} fill="#fff" opacity="0.85" />
        </svg>
    );
};

export default ApertureEye;
